function FbaModules() {
    this.modules = {};
    this.requires = {};
    this.loaded = {};
}

FbaModules.prototype.add = function(name, requires, module) {
    this.modules[name] = module;
    this.requires[name] = requires;
    this.loaded[name] = null;
}

FbaModules.prototype.load = function(name, loading = []) {
    if (!this.loaded.hasOwnProperty(name)) {
        throw "invalid fbamodule " + name + " not added";
    }
    if (this.loaded[name] !== null) {
        return this.loaded[name];
    }

    let args = [];
    for (let i in this.requires[name]) {
        args.push(this.load(this.requires[name][i], loading));
    }

    this.loaded[name] = this.modules[name](...args);
    return this.loaded[name];
}

const fbm = new FbaModules();



